{
  "Dashboard": "儀表板",
  "BlyCareShippingProte": "BlyCare 運輸保障",
  "LoadingBlyCare": "正在載入 BlyCare…",
  "LoadingWidgetSetting": "正在載入小部件設定…",
  "PreparingYourWorkspa": "正在準備您的工作區",
  "Language": "語言",
  "English": "English",
  "EnglishDefault": "English（預設）",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "設定指南",
  "CompletedOfTotalComp": "已完成 {{completed}}/{{total}}",
  "Dismiss": "關閉",
  "MoreActions": "更多操作",
  "ToggleSetupGuide": "切換設定指南",
  "ActivateAppEmbed": "啟用應用程式嵌入",
  "ClickTheEnableButton": "1. 點擊下方的「啟用」按鈕，開啟您的 Shopify 主題編輯器。",
  "BlyCareEmbedSection": "2. 在左側「應用程式嵌入」區段中找到 BlyCare。確認其開關已開啟，然後點擊右上角的「儲存」。",
  "Enable": "啟用",
  "PublishWidget": "發布小部件",
  "PublishStorefront": "在商店前台發布小部件，供顧客購買。",
  "Publish": "發布",
  "SetProtectionFee": "設定保障費",
  "FeeYouWantToCharge": "設定您要向顧客收取的費用。",
  "Setup": "設定",
  "TestYourWidgetOnYour": "在您的商店測試小部件",
  "AddAProductToYourCar": "將商品加入購物車，確認出現運輸保障小部件。選擇運輸保障，然後繼續結帳，並確認結帳頁面中包含運輸保障商品。",
  "TestNow": "立即測試",
  "Working": "一切正常",
  "NeedHelp": "需要協助",
  "MarkAsCompleted": "標記為已完成",
  "AppStatus": "應用程式狀態",
  "AppEmbed": "應用程式嵌入",
  "EnableAppEmbedToDisp": "啟用應用程式嵌入以在購物車顯示運輸保障。",
  "CartPage": "在購物車頁面顯示運輸保障。",
  "CheckoutBlock": "結帳區塊",
  "CheckoutPage": "在結帳頁面顯示運輸保障。",
  "Active": "已啟用",
  "Inactive": "未啟用",
  "Analytics": "分析",
  "Today": "今天",
  "Last7Days": "最近 7 天",
  "Last30Days": "最近 30 天",
  "Last60Days": "最近 60 天",
  "Last90Days": "最近 90 天",
  "Last365Days": "最近 365 天",
  "Custom": "自訂",
  "Start": "開始",
  "End": "結束",
  "DateRange": "日期範圍",
  "SelectedRange": "已選範圍：{{range}}",
  "Cancel": "取消",
  "Save": "儲存",
  "ChooseAStartDateOnOr": "請選擇不晚於結束日期的開始日期，且不要選擇今天之後的日期。",
  "PreviousMonth": "上個月",
  "NextMonth": "下個月",
  "ProtectionRevenue": "保障營收",
  "ProtectedOrders": "已保障訂單",
  "ProtectedOrderRate": "訂單保障率",
  "LoadingAnalytics": "正在載入分析資料…",
  "AnalyticsCouldNotLo": "無法載入分析資料",
  "RetryAnalytics": "重試分析",
  "Resources": "資源",
  "HowDoesShippingProte": "運輸保障如何運作？",
  "BlyCareAddsAShipping": "BlyCare 會在您的購物車中加入運輸保障小部件。顧客可選擇為訂單新增保障。由商家收取保障費、決定承保範圍，並使用這些費用處理索賠。",
  "DoesBlyCareCoverInsu": "BlyCare 是否承保保險索賠？",
  "NoBlyCareIsNotInsura": "否。BlyCare 不是保險，也不支付索賠。BlyCare 僅為商家提供小部件和工具，以管理自己的運輸保障計畫。",
  "EmailUs": "透過電子郵件聯絡我們",
  "LiveChat": "即時聊天",
  "HelpCenter": "幫助中心",
  "Settings": "設定",
  "CheckoutWidget": "結帳小部件",
  "CartWidget": "購物車小部件",
  "PriceSetting": "價格設定",
  "ProductSetting": "商品設定",
  "AdminLanguage": "管理後台語言",
  "AdminLanguageTitle": "管理後台語言",
  "AdminLanguageHelp": "僅變更您自己的應用程式語言，不影響顧客。",
  "AppLanguage": "應用程式語言",
  "UnableToLoadSettings": "無法載入設定",
  "TryAgain": "重試",
  "Discard": "捨棄",
  "LoadingSettings": "正在載入設定",
  "PageNotFound": "找不到頁面",
  "ProductSettingsCould": "無法儲存商品設定。",
  "Fulfillment": "履約",
  "FulfillmentHelp": "選擇保障商品何時標記為已履約。",
  "ManuallyFulfill": "手動履約",
  "MarkFulfilledWhenFir": "訂單中第一件商品履約後標記為已履約",
  "MarkFulfilledWhenAll": "訂單中所有其他商品履約後標記為已履約",
  "MarkFulfilledImmedi": "訂單建立後立即標記為已履約",
  "Exclusions": "排除",
  "ExclusionsHelp": "選擇不適用保障的情況。",
  "ExclusionType": "排除類型",
  "Select": "選擇",
  "SelectedExclusions": "已選排除項目",
  "RemoveName": "移除 {{name}}",
  "WhenExcluded": "排除時",
  "HideWidget": "隱藏小部件",
  "KeepWidgetButSkipThe": "保留小部件但略過費用",
  "ExcludeProductType": "排除商品類型",
  "SearchProductType": "搜尋商品類型",
  "ExcludeSKU": "排除 SKU",
  "SearchSKU": "搜尋 SKU",
  "ExcludeCollection": "排除商品系列",
  "SearchCollection": "搜尋商品系列",
  "ExcludeMarket": "排除市場",
  "SearchMarket": "搜尋市場",
  "ExcludeLanguage": "排除語言",
  "SearchLanguage": "搜尋語言",
  "Add": "新增",
  "PriceSettingsCouldNo": "無法儲存價格設定。",
  "ShippingProtectionPr": "運輸保障價格",
  "SetHowMuchPriceDoYou": "設定您要向顧客收取的金額",
  "PricingMethod": "定價方式",
  "Fixed": "固定",
  "Percentage": "百分比",
  "UniversalProtectionP": "通用保障價格",
  "PercentageOfCartSubt": "購物車小計百分比",
  "EditCappedPrice": "編輯封頂價格",
  "ShippingProtectionFe": "依百分比計算的運輸保障費，起價為 {{minPrice}} USD，每階遞增 {{increment}} USD，封頂為 {{capped}} USD。",
  "MinProtectionFee": "最低保障費",
  "IncrementAmount": "遞增金額",
  "CappedProtectionFee": "封頂保障費",
  "AddTierPrice": "新增階梯價格",
  "AddTier": "新增階梯",
  "TierPriceHelp": "如果購物車金額與任何階梯購物車價格範圍都不相符，將適用您在上一頁設定的通用價格。",
  "MinCartPrice": "最低購物車金額",
  "MaxCartPrice": "最高購物車金額",
  "ProtectionFee": "保障費",
  "RemoveTier": "移除階梯",
  "Required": "必填",
  "ThisFieldIsRequired": "此欄位為必填。",
  "MustBeGreaterThanZero": "{{label}} 必須大於 0。",
  "MustBeOrLess": "{{label}} 必須小於或等於 {{max}}。",
  "AtMostTwoDecimals": "{{label}} 最多可有 2 位小數。",
  "MustBeLargerThanMinC": "必須大於最低購物車金額",
  "MustBeLargerThanMaxC": "必須大於最高購物車金額",
  "MustBeSmallerThanMin": "必須小於最低購物車金額",
  "Price": "價格",
  "MinimumPrice": "最低價格",
  "Increment": "遞增",
  "CartPageWidget": "購物車頁面小部件",
  "CheckoutPageWidget": "結帳頁面小部件",
  "WidgetFormat": "小部件格式",
  "TickerWidget": "普通小部件",
  "CheckoutButtonWidget": "結帳按鈕小部件",
  "Text": "文字",
  "MainText": "主要文字",
  "Title": "標題",
  "Description": "說明",
  "MainButtonText": "主要按鈕文字",
  "SecondaryButtonText": "次要按鈕文字",
  "EnabledDescription": "啟用時的說明",
  "DisabledDescription": "停用時的說明",
  "PleaseEnterTitle": "請輸入標題",
  "PleaseEnterDescript": "請輸入說明",
  "PleaseEnterMainButt": "請輸入主要按鈕文字",
  "PleaseEnterSecondar": "請輸入次要按鈕文字",
  "PleaseEnterEnabledD": "請輸入啟用時的說明",
  "PleaseEnterDisabled": "請輸入停用時的說明",
  "EGViewTerms": "例如：查看條款",
  "EGHttpTerms": "例如：https://terms.com",
  "Footer": "頁尾",
  "FooterText": "頁尾文字",
  "FooterLink": "頁尾連結",
  "TooltipLink": "提示連結",
  "FooterVisibility": "頁尾可見性",
  "TitleInfoVisibility": "標題資訊可見性",
  "Disabled": "停用",
  "Enabled": "啟用",
  "Color": "顏色",
  "ColorStyle": "顏色樣式",
  "SizeAndDisplay": "尺寸與顯示",
  "IconSize": "圖示尺寸",
  "IconRadius": "圖示圓角",
  "BorderSize": "邊框粗細",
  "BorderRadius": "邊框圓角",
  "HorizontalPadding": "水平內距",
  "VerticalPadding": "垂直內距",
  "ToggleFormat": "切換格式",
  "Switch": "開關",
  "Checkbox": "核取方塊",
  "Border": "邊框",
  "Background": "背景",
  "ProtectionDescript": "保障說明",
  "MainButtonBackgrou": "主要按鈕背景",
  "EnabledToggle": "啟用狀態開關",
  "DisabledToggle": "停用狀態開關",
  "Automatic": "自動",
  "Neutral": "中性",
  "Info": "資訊",
  "Success": "成功",
  "Warning": "警告",
  "Critical": "嚴重",
  "Subdued": "柔和",
  "Transparent": "透明",
  "ThemeColor": "主題顏色",
  "ResetToDefaultColor": "{{label}}：重設為預設顏色",
  "OpenColorPicker": "{{label}}：開啟顏色選擇器",
  "Icon": "圖示",
  "PackageIcon": "包裹圖示",
  "PackageIconNumber": "包裹圖示 {{value}}",
  "UploadIcon": "上傳圖示",
  "NoIcon": "無圖示",
  "AcceptedFormats": "支援的格式：PNG、JPG、SVG",
  "MaximumFileSize": "檔案大小上限：50 MB",
  "AddFiles": "新增檔案",
  "RemoveImage": "移除圖片",
  "Uploading": "正在上傳",
  "UploadFailedTryAgain": "上傳失敗，請重試。",
  "ChooseAJPEGPNG": "請選擇不超過 50 MB 的 JPEG、PNG 或 SVG 圖片。",
  "ChooseNonemptyImage": "請選擇非空且不超過 50 MB 的 JPEG、JPG、PNG 或 SVG 圖片。",
  "ImageCouldNotBeRead": "無法讀取此圖片。",
  "FileContentsMismatch": "檔案內容必須與其 JPEG、PNG 或 SVG 圖片類型相符。",
  "ImageCouldNotBeDecode": "無法解碼此圖片。",
  "InvalidImageUrl": "上傳服務傳回了無效的圖片 URL。",
  "MissingPublicImageUrl": "上傳服務未傳回公開的圖片 URL。",
  "CustomCssTooLong": "自訂 CSS 最多可包含 2,000 個字元。",
  "ChooseValidIconUrl": "請選擇具有有效 URL 的上傳圖示。",
  "EnterNumberRange": "請輸入 {{min}} 到 {{max}} 之間的數字。",
  "EnterLocaleTextRange": "請輸入 {{locale}} 文字，長度介於 1 到 {{limit}} 個字元之間。",
  "EnterValidLearnMoreUrl": "請輸入以 https:// 或 http:// 開頭的有效「了解更多」URL。",
  "ReviewHighlightedFields": "請檢查醒目提示的欄位。",
  "CannotChangePublishState": "表單通過驗證前無法變更發布狀態：{{reason}}",
  "BlyCareCouldNotSave": "BlyCare 無法儲存。",
  "CheckoutRequiresPlus": "自訂結帳頁面需要 Shopify Plus。",
  "SaveSucceededReloadFailed": "儲存請求已成功，但無法載入最新的小部件設定。請重新整理以確認您的變更。",
  "BlyCareCouldNotComplete": "BlyCare 無法完成此請求。",
  "ShopifyAuthorizationRequired": "需要 Shopify 授權。",
  "AppBridgeUnavailable": "Shopify App Bridge 無法使用",
  "ExtensionStatusUnavailable": "Shopify 擴充功能狀態無法使用。",
  "ConfigurationPreview": "設定預覽",
  "On": "開",
  "Off": "關",
  "Unpublish": "取消發布",
  "AppEmbedIsNotEnable": "應用程式嵌入未啟用。",
  "GoEnabled": "前往啟用",
  "ViewOnYourStorefront": "在商店前台查看",
  "PreviewProtection": "預覽保障",
  "MoreInformation": "更多資訊",
  "Cart": "購物車",
  "Subtotal": "小計",
  "Checkout": "結帳",
  "DiscountCode": "折扣碼",
  "Apply": "套用",
  "Shipping": "運費",
  "Total": "總計",
  "ShippingProtection": "運輸保障",
  "Product": "商品",
  "CopyLink": "複製連結"
}
